export default __webpack_public_path__ + "static/media/logo-text-alt.4d16436b.svg";